import { ErrorType } from '@rover/rsdk/src/modules/Network/orvalHTTPInterface';
import {
  Http403Error,
  Http404Error,
  Http410Error,
  Http429Error,
  Http500Error,
} from '@rover/utilities/HttpError';

type QueryError = ErrorType<Error>; // Parameter is a no op
type RoverError = Http403Error | Http404Error | Http410Error | Http429Error | Http500Error;
type ErrorConstructor = new () => RoverError;

export const ERROR_FOR_STATUS_CODE: Record<number, ErrorConstructor> = {
  404: Http404Error,
  403: Http403Error,
  410: Http410Error,
  429: Http429Error,
  500: Http500Error,
};

/**
 * This function attempts to map react-query HTTP errors to an instance of the `HttpXXXError` classes.
 */
const getQueryError = (...errors: Array<QueryError | null>): RoverError & QueryError => {
  return errors
    .map((err) => {
      if (!err) return null;
      if (!('res' in err)) return null;
      const statusCode = String(typeof err.res === 'object' ? err.res.status : err.res);
      if (Object.keys(ERROR_FOR_STATUS_CODE).includes(statusCode)) {
        const PredefinedError: ErrorConstructor = ERROR_FOR_STATUS_CODE[statusCode];
        return new PredefinedError();
      }
      return err;
    })
    .filter((el): el is RoverError & QueryError => Boolean(el))[0];
};

export default getQueryError;
